(function() {
  'use strict';

  function FilterMenuCtrl ($state, mdPanelRef) {
    var panelRef = mdPanelRef;
    var ctrl = this;

    ctrl.onStatusChange = function () {
      ctrl.isAllDisabled = _.every(ctrl.statuses, {'isChecked': false});
    };

    ctrl.onStatusChange();

    ctrl.closeMenu = function (closeReason) {
      if (!panelRef) { return; }
      panelRef.close({
        submited: closeReason === 'submit',
        statuses: ctrl.statuses
      })
      .then(function(){
        panelRef.destroy();
      });
    };

    ctrl.goToConfig = function () {
      if (!panelRef) { return; }
      panelRef.close().then(function(){
        panelRef.destroy();
      });
      $state.go('integration-config', { provider: ctrl.provider.slug });
    };

    ctrl.clearAll = function () {
      _.forEach(ctrl.statuses, function(status){
        status.isChecked = false;
      });
    };
  }

  angular
    .module('mandaeApp')
    .controller('FilterMenuCtrl', FilterMenuCtrl);

}());
